import { useQuery } from "react-query";
import { publicService } from '../../services/publicService';

export const useBrigades = () => {
  return useQuery({
    queryKey: ["brigades"],
    queryFn: publicService.getBrigades,
  });
};
